import { render, staticRenderFns } from "./_products-matrix.component.vue?vue&type=template&id=c4e7083e&scoped=true"
import script from "./_products-matrix.component.vue?vue&type=script&lang=js"
export * from "./_products-matrix.component.vue?vue&type=script&lang=js"
import style0 from "./_products-matrix.component.vue?vue&type=style&index=0&id=c4e7083e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4e7083e",
  null
  
)

export default component.exports